import { Grid } from '@mui/material';

import { Select } from '@occc-app/design-system';

import { WalletValueInput } from './WalletValueInput';

import { WalletSteeringSelectNotMultiple } from '../WalletSteeringSelectNotMultiple';
import { dimensionOptions, operatorOptions } from '../constants';

type WalletSteeringFormArrayItemsProps = {
  fieldArrayName: string;
};

export const WalletSteeringFormArrayItem = ({
  fieldArrayName,
}: WalletSteeringFormArrayItemsProps) => {
  return (
    <>
      <Grid container columnSpacing={3} rowSpacing={2}>
        <Grid item md={3} sm={6}>
          <WalletSteeringSelectNotMultiple
            name={`${fieldArrayName}.wallet`}
            label='Select Wallet'
          />
        </Grid>
        <Grid item md={3} sm={6}>
          <Select
            name={`${fieldArrayName}.dimension`}
            label='Target'
            data={dimensionOptions}
            formControlProps={{ size: 'medium', margin: 'none' }}
          />
        </Grid>
        <Grid item md={3} sm={6}>
          <Select
            name={`${fieldArrayName}.operator`}
            label='Choose a trend'
            data={operatorOptions}
            formControlProps={{ size: 'medium', margin: 'none' }}
          />
        </Grid>
        <Grid item md={3} sm={6}>
          <WalletValueInput fieldArrayName={fieldArrayName} />
        </Grid>
      </Grid>
    </>
  );
};
